import { observer } from 'mobx-react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { segmentRoute } from '../../ClientRoutes';
import { UpcomingProgram, upcomingCurrentSegment } from '../../ProgramStore/Types';
import { Link } from '../../Resource/Types';
import { AlreadyTranslated, NotTranslated } from '../../Translations';
import UniversityLogoOnWhite from '../Dashboard/UniversityLogoOnWhite';
import * as style from './style.module.css';

interface Props {
  programDetail: UpcomingProgram;
  links: ReadonlyArray<Link>;
}

const ProgramCard: React.FC<Props> = ({ programDetail, links }) => (
  <div className={style.program} data-test-upcoming-program={true}>
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.header}>
          <h3 className={style.title} data-test-program-title={programDetail.title.text}>
            <AlreadyTranslated content={programDetail.title} />
          </h3>
        </div>
        <p className={style.message} data-test-program-message={programDetail.message}>
          <NotTranslated text={programDetail.message} />
        </p>
      </div>
      <div className={style.logo}>
        <UniversityLogoOnWhite links={links} />
      </div>
    </div>
  </div>
);

// The whole card opens the course at the learner's current segment. The program has
// not started, so the segment page shows when it opens, with the course tools.
const UpcomingProgramOverview: React.FC<Props> = (props) =>
  upcomingCurrentSegment(props.programDetail)
    .map((segment) => (
      <RouterLink
        to={segmentRoute(segment)}
        className="block text-inherit no-underline transition-shadow hover:shadow-md"
        data-intercom-target="dashboard-upcoming-program-link"
        data-test-upcoming-program-link={segment.id}
      >
        <ProgramCard {...props} />
      </RouterLink>
    ))
    .getOrElse(() => <ProgramCard {...props} />);

export default observer(UpcomingProgramOverview);
